import "./about.css"
export default function About()
{
    return(
        <>
        <div className="cardContainer">
            <div className="card1">
                <div className="mycard">
                    <h4>Mayuresan</h4>
                   <div><h6>Mern stack developer</h6></div>
                   <div><h6>www.linkedin.com/in/mayuresan-yokendran-165300158</h6></div>
                </div>
            </div>
        </div>
        </>
    )
}